"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const org_transcrypt___runtime___js_1 = require("./org.transcrypt.__runtime__.js");
const encerrors = __importStar(require("./tfchain.encoding.errors.js"));
const jsstr = __importStar(require("./tfchain.polyfill.encoding.str.js"));
const jsbin = __importStar(require("./tfchain.polyfill.encoding.bin.js"));
const jsarr = __importStar(require("./tfchain.polyfill.array.js"));
var __name__ = 'tfchain.encoding.siabin';
exports._INT_UPPERLIMIT = org_transcrypt___runtime___js_1.pow(2, 64) - 1;
exports.encode_all = function () {
    if (arguments.length) {
        var __ilastarg0__ = arguments.length - 1;
        if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
            var __allkwargs0__ = arguments[__ilastarg0__--];
            for (var __attrib0__ in __allkwargs0__) {
            }
        }
        var py_values = org_transcrypt___runtime___js_1.tuple([].slice.apply(arguments).slice(0, __ilastarg0__ + 1));
    }
    else {
        var py_values = org_transcrypt___runtime___js_1.tuple();
    }
    var enc = exports.SiaBinaryEncoder();
    enc.add_all(...py_values);
    return enc.data;
};
exports.SiaBinaryObjectEncoderBase = org_transcrypt___runtime___js_1.__class__('SiaBinaryObjectEncoderBase', [org_transcrypt___runtime___js_1.object], {
    __module__: __name__,
    get sia_binary_encode() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, encoder) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'encoder':
                                var encoder = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            var __except0__ = org_transcrypt___runtime___js_1.NotImplementedError('sia_binary_encode not yet implemented');
            __except0__.__cause__ = null;
            throw __except0__;
        });
    }
});
exports.SiaBinaryEncoder = org_transcrypt___runtime___js_1.__class__('SiaBinaryEncoder', [org_transcrypt___runtime___js_1.object], {
    __module__: __name__,
    get __init__() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            self._data = org_transcrypt___runtime___js_1.bytes();
        });
    },
    get _get_data() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            return self._data;
        });
    },
    get reset() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            self._data = org_transcrypt___runtime___js_1.bytes();
        });
    },
    get add_int() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, value) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'value':
                                var value = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            if (!(org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.int))) {
                var __except0__ = org_transcrypt___runtime___js_1.py_TypeError('value is not an integer');
                __except0__.__cause__ = null;
                throw __except0__;
            }
            if (value < 0) {
                var __except0__ = encerrors.IntegerOutOfRange('integer {} is out of lower range of 0'.format(value));
                __except0__.__cause__ = null;
                throw __except0__;
            }
            if (value > exports._INT_UPPERLIMIT) {
                var __except0__ = encerrors.IntegerOutOfRange('integer {} is out of upper range of {}'.format(value, exports._INT_UPPERLIMIT));
                __except0__.__cause__ = null;
                throw __except0__;
            }
            self._data = jsarr.concat(self._data, jsbin.from_int64(value));
        });
    },
    get add_array() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, value) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'value':
                                var value = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            if (org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.str)) {
                self._data = jsarr.concat(self._data, jsstr.to_utf8(value));
            }
            else if (org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.tuple([org_transcrypt___runtime___js_1.bytes, org_transcrypt___runtime___js_1.bytearray]))) {
                self._data = jsarr.concat(self._data, org_transcrypt___runtime___js_1.bytes(value));
            }
            else if (jsarr.is_uint8_array(value)) {
                self._data = jsarr.concat(self._data, value);
            }
            else {
                try {
                    var result = org_transcrypt___runtime___js_1.bytes();
                    for (var element of value) {
                        self.add(element);
                    }
                    return result;
                }
                catch (__except0__) {
                    if (org_transcrypt___runtime___js_1.isinstance(__except0__, org_transcrypt___runtime___js_1.py_TypeError)) {
                        var __except1__ = org_transcrypt___runtime___js_1.py_TypeError('value cannot be encoded as an array');
                        __except1__.__cause__ = null;
                        throw __except1__;
                    }
                    else {
                        throw __except0__;
                    }
                }
            }
        });
    },
    get add_slice() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, value) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'value':
                                var value = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            if (org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.str)) {
                self.add_int(org_transcrypt___runtime___js_1.len(value));
                self._data = jsarr.concat(self._data, jsstr.to_utf8(value));
            }
            else if (org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.tuple([org_transcrypt___runtime___js_1.bytes, org_transcrypt___runtime___js_1.bytearray]))) {
                self.add_int(org_transcrypt___runtime___js_1.len(value));
                self._data = jsarr.concat(self._data, org_transcrypt___runtime___js_1.bytes(value));
            }
            else if (jsarr.is_uint8_array(value)) {
                self.add_int(org_transcrypt___runtime___js_1.len(value));
                self._data = jsarr.concat(self._data, value);
            }
            else {
                var length = 0;
                for (var _ of value) {
                    length++;
                }
                self.add_int(length);
                self.add_array(value);
            }
        });
    },
    get add_byte() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, value) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'value':
                                var value = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            if (org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.int)) {
                if (value < 0 || value > 255) {
                    var __except0__ = org_transcrypt___runtime___js_1.ValueError('byte overflow: invaid value of {}'.format(value));
                    __except0__.__cause__ = null;
                    throw __except0__;
                }
                self._data = jsarr.concat(self._data, jsbin.from_int8(value));
            }
            else {
                if (org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.str)) {
                    var value = jsstr.to_utf8(value);
                }
                else if (!(org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.tuple([org_transcrypt___runtime___js_1.bytes, org_transcrypt___runtime___js_1.bytearray]))) && !(jsarr.is_uint8_array(value))) {
                    var __except0__ = org_transcrypt___runtime___js_1.ValueError('value of type {} cannot be added as a single byte'.format(org_transcrypt___runtime___js_1.py_typeof(value)));
                    __except0__.__cause__ = null;
                    throw __except0__;
                }
                if (org_transcrypt___runtime___js_1.len(value) != 1) {
                    var __except0__ = org_transcrypt___runtime___js_1.ValueError('a single byte has to be accepted, amount of bytes given: {}'.format(org_transcrypt___runtime___js_1.len(value)));
                    __except0__.__cause__ = null;
                    throw __except0__;
                }
                if (jsarr.is_uint8_array(value)) {
                    self._data = jsarr.concat(self._data, value);
                }
                else {
                    self._data = jsarr.concat(self._data, org_transcrypt___runtime___js_1.bytes(value));
                }
            }
        });
    },
    get add() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self, value) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                            case 'value':
                                var value = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
            }
            else {
            }
            if (org_transcrypt___runtime___js_1.isinstance(value, exports.SiaBinaryObjectEncoderBase)) {
                value.sia_binary_encode(org_transcrypt___runtime___js_1.__kwargtrans__({ encoder: self }));
                return;
            }
            if (org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.bool)) {
                self._data = jsarr.concat(self._data, (value ? org_transcrypt___runtime___js_1.bytes([1]) : org_transcrypt___runtime___js_1.bytes([0])));
            }
            else if (org_transcrypt___runtime___js_1.isinstance(value, org_transcrypt___runtime___js_1.int)) {
                self.add_int(value);
            }
            else {
                try {
                    return self.add_slice(value);
                }
                catch (__except0__) {
                    if (org_transcrypt___runtime___js_1.isinstance(__except0__, org_transcrypt___runtime___js_1.py_TypeError)) {
                        // pass;
                    }
                    else {
                        throw __except0__;
                    }
                }
                var __except0__ = org_transcrypt___runtime___js_1.ValueError('cannot siabin-encode value with unsupported type {}'.format(org_transcrypt___runtime___js_1.py_typeof(value)));
                __except0__.__cause__ = null;
                throw __except0__;
            }
        });
    },
    get add_all() {
        return org_transcrypt___runtime___js_1.__get__(this, function (self) {
            if (arguments.length) {
                var __ilastarg0__ = arguments.length - 1;
                if (arguments[__ilastarg0__] && arguments[__ilastarg0__].hasOwnProperty("__kwargtrans__")) {
                    var __allkwargs0__ = arguments[__ilastarg0__--];
                    for (var __attrib0__ in __allkwargs0__) {
                        switch (__attrib0__) {
                            case 'self':
                                var self = __allkwargs0__[__attrib0__];
                                break;
                        }
                    }
                }
                var py_values = org_transcrypt___runtime___js_1.tuple([].slice.apply(arguments).slice(1, __ilastarg0__ + 1));
            }
            else {
                var py_values = org_transcrypt___runtime___js_1.tuple();
            }
            for (var value of py_values) {
                self.add(value);
            }
        });
    }
});
Object.defineProperty(exports.SiaBinaryEncoder, 'data', org_transcrypt___runtime___js_1.property.call(exports.SiaBinaryEncoder, exports.SiaBinaryEncoder._get_data));
;
//# sourceMappingURL=tfchain.encoding.siabin.map
//# sourceMappingURL=tfchain.encoding.siabin.js.map